<template>
    <div class="sm:col-span-12">
        <div class="sm:col-span-12">
            <div class="mt-1">
                <FormLabel :value="$t('messages.accepts_equivalent_explanation')" for="accepts_equivalent" />
                <input
                    name="selected"
                    v-model="form.accepts_equivalent"
                    id="accepts_equivalent"
                    type="checkbox"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                />
            </div>
        </div>

        <div>
            <FormLabel :value="$t('messages.numerator')" for="numerator" />
            <FormInput
                id="numerator"
                v-model.number="form.numerator"
                name="numerator"
                @keypress.enter.prevent
                :placeholder="$t('messages.numerator')"
                type="number"
                required
                step="1"
                class="mt-1 w-40"
            />
            <FormError :value="errors[`options.numerator`]" class="mt-2" />

            <div class="mt-3 border-t-2 border-gray-300 w-40">
                <FormLabel :value="$t('messages.denominator')" for="denominator" />
                <FormInput
                    id="denominator"
                    v-model.number="form.denominator"
                    name="denominator"
                    @keypress.enter.prevent
                    :placeholder="$t('messages.denominator')"
                    type="number"
                    required
                    step="1"
                    class="mt-3 w-40"
                />
                <FormError :value="errors[`options.denominator`]" class="mt-2" />
            </div>
        </div>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    name: 'QuestionMathFractionOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    methods: {
        deleteOption(answers, index) {
            answers.splice(index, 1);
        },
        addOption() {
            this.form.answers.push({ text: '' });
        },
    },
    mounted() {
        let defaultOptions = {
            accepts_equivalent: true,
            numerator: '',
            denominator: '',
        };
        if (!this.form.hasOwnProperty('numerator')) {
            Object.entries(defaultOptions).forEach((entry) => (this.form[entry[0]] = entry[1]));
        }
    },
};
</script>
